/* Verona Tempo r12: vt-r12-look. See REVAMP-LOG.md "Round 12". */
/*
  Round 12 — look & speed (design + technical helper). Loaded (defer) on every page.
  - D6 photo fade-in (html.vt-r12-fade + html.vt-anim, not with reduced motion): lazy photos that have not arrived yet get
    .vt-r12-ld (invisible, the light-green box shows), then .vt-r12-in (short fade) when they arrive. Photos already loaded
    are never touched, so nothing flashes; if this file fails no class is added and photos show as usual.
  - D9 homepage lines (html.vt-r12-div): marks the homepage sections that get a fine olive line on top (.vt-r12-divtop).
  Styles: assets/vt-r12-look.css.
*/
(function () {
  "use strict";
  var root = document.documentElement;
  var cls = root.classList;

  /* ------------------------------------------------------------ D6: gentle fade-in for photos */
  var reduce = false;
  try { reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches; } catch (e) {}
  if (cls.contains("vt-r12-fade") && cls.contains("vt-anim") && !reduce) {
    var reveal = function (img) {
      if (!img.classList.contains("vt-r12-ld")) return;
      img.classList.remove("vt-r12-ld");
      if (img.naturalWidth > 0) {
        img.classList.add("vt-r12-in");
        img.addEventListener("animationend", function () { img.classList.remove("vt-r12-in"); }, { once: true });
      }
    };
    var onDone = function (e) { reveal(e.target); };
    var shopImg = /\/cdn\/shop\/|cdn\.shopify\.com/;
    var take = function (img) {
      if (img.__vtR12) return;
      // 27 Oct 2026: a COPY of a photo that is still marked "loading" (phone swipe strip, colour dot, filter copies)
      // carries the mark but not the listener that removes it, so it stayed invisible for ever: watch it too, or show
      // it now if it is already there
      if (img.classList.contains("vt-r12-ld")) {
        img.__vtR12 = 1;
        if (img.complete) { reveal(img); return; }
        img.addEventListener("load", onDone, { once: true });
        img.addEventListener("error", onDone, { once: true });
        return;
      }
      if (img.complete) return;
      // 2 Nov 2026: a photo already showing that is fetching a sharper file (vt-line.js asks for it) is not hidden again
      if (img.naturalWidth > 0 || img.classList.contains("is-lined")) return;
      if (img.getAttribute("loading") !== "lazy" || img.getAttribute("fetchpriority") === "high") return;
      if (!shopImg.test(img.getAttribute("src") || img.getAttribute("srcset") || img.getAttribute("data-src") || "")) return;
      if (img.closest("[id^='kangaroo'], .kangaroo-container, [class*='-kr ']")) return;
      img.__vtR12 = 1;
      img.addEventListener("load", onDone, { once: true });
      img.addEventListener("error", onDone, { once: true });
      img.classList.add("vt-r12-ld");
      if (img.complete) reveal(img); // arrived in between
    };
    var scan = function (node) {
      if (!node || node.nodeType !== 1) return;
      if (node.tagName === "IMG") { take(node); return; }
      var list = node.getElementsByTagName("img");
      for (var i = 0; i < list.length; i++) take(list[i]);
    };
    scan(document.body);
    if ("MutationObserver" in window) {
      new MutationObserver(function (records) {
        for (var r = 0; r < records.length; r++) {
          var added = records[r].addedNodes;
          for (var n = 0; n < added.length; n++) scan(added[n]);
        }
      }).observe(document.body, { childList: true, subtree: true });
    }
    // safety: anything that finished loading without us hearing it is shown
    window.addEventListener("load", function () {
      var left = document.querySelectorAll("img.vt-r12-ld");
      for (var i = 0; i < left.length; i++) if (left[i].complete) reveal(left[i]);
    });
  }

  /* ------------------------------------------------------------ D9: fine lines between homepage sections */
  if (cls.contains("vt-r12-div") && document.body && document.body.classList.contains("template-index")) {
    var clear = function (c) { var m = /rgba?\(([^)]+)\)/.exec(c); if (!m) return true; var p = m[1].split(","); if (p.length === 4 && parseFloat(p[3]) === 0) return true; return false; };
    var white = function (c) { return /rgba?\(\s*255,\s*255,\s*255(,\s*1)?\s*\)/.test(c); };
    // Sections further down are drawn lazily (content-visibility: auto in vt-home.css), so their sizes are placeholders:
    // decide from styles and content only, never from heights.
    // white page section = no coloured background on the section, its direct children, or the first child's first child
    var coloured = function (el) { if (!el) return false; var bg = getComputedStyle(el).backgroundColor; return !clear(bg) && !white(bg); };
    var plain = function (sec) {
      if (coloured(sec)) return false;
      for (var c = sec.firstElementChild; c; c = c.nextElementSibling) if (coloured(c)) return false;
      return !coloured(sec.firstElementChild && sec.firstElementChild.firstElementChild);
    };
    // shown = has words or pictures, and its content is not hidden
    var shown = function (sec) {
      if (getComputedStyle(sec).display === "none") return false;
      var any = false;
      for (var c = sec.firstElementChild; c; c = c.nextElementSibling) {
        if (/^(SCRIPT|STYLE|TEMPLATE|LINK)$/.test(c.tagName) || c.hidden || getComputedStyle(c).display === "none") continue;
        any = true; break;
      }
      if (!any) return false;
      return !!(sec.textContent.trim() || sec.querySelector("img, svg, video, iframe"));
    };
    var hasLine = function (el, side) {
      for (var d = 0; d < 3 && el; d++) {
        var cs = getComputedStyle(el);
        if (parseFloat(cs["border" + side + "Width"]) > 0 && cs["border" + side + "Style"] !== "none") return true;
        el = side === "Top" ? el.firstElementChild : el.lastElementChild;
      }
      return false;
    };
    var mark = function () {
      var main = document.getElementById("main") || document.querySelector("main");
      if (!main) return;
      var secs = main.querySelectorAll(":scope > .shopify-section, :scope > * > .shopify-section");
      var prev = null;
      for (var i = 0; i < secs.length; i++) {
        var s = secs[i];
        var on = false;
        if (shown(s)) {
          var isPlain = plain(s);
          on = i > 0 && prev && prev.plain && prev.index > 0 && isPlain && !hasLine(s, "Top") && !hasLine(prev.el, "Bottom");
          prev = { el: s, plain: isPlain, index: i };
        }
        s.classList.toggle("vt-r12-divtop", !!on);
      }
    };
    var later = function () { try { mark(); } catch (e) {} };
    later();
    window.addEventListener("load", later);
    setTimeout(later, 3000);
  }
})();
